import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CHART_COLORS, paginationChange } from '@common/interfaces';
import { ChartOptions } from 'chart.js';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-workspace-insights',
  templateUrl: './workspace-insights.component.html',
  styleUrls: ['./workspace-insights.component.scss']
})
export class WorkspaceInsightsComponent implements OnInit {
  loaderView!: boolean;
  loading = false;
  options: any[] | null = [{ name: 'Show All' }];
  @Output() paginatorEmitter = new EventEmitter<any>();
  title: any;
  @Output() pageSizeChange = new EventEmitter<string>();
  selectedOption: string = 'Show All';
  chartSelectedOption: string = 'Show All';
  status: string = '';
  searchColumn!: string;
  pageCount!: any;
  searchText!: string;
  pageSizeOptions = ['5', '10', '15'];
  count: number = 0;
  provider!: string;
  currentParams: any;
  pageSize = '5';
  rawData: any = { results: [], totalUsers: 0 };
  dummyOptions = [{ name: 'Show All' }]
  displayedColumns: string[] = [
    'Workspaces',
    "Asset Type Count"
  ];
  isChartDataEmpty = false;
  dataSource: { Workspace: string; assetTypeCount: number }[] = []
  subscriptionData: {
    plancount: { plan: string; workspaceCount: number }[];
    count: number;
  } = {
      plancount: [],
      count: 0
    }
  public pieChartLabels: string[] = [];
  public subscriptionChartLabels: string[] = [];
  pieChartData!: any;
  subscriptionPieChart!: {
    labels: string[];
    datasets: { data: number[]; backgroundColor: string[]; hoverBackgroundColor: string[] }[];
  };
  public pieChartType: 'doughnut' = 'doughnut';
  pieChartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    cutout: '70%', // Donut thickness
    plugins: {
      legend: {
        position: 'right',
        labels: {
          color: '#333',
          usePointStyle: true,
          pointStyle: 'circle'
        }
      },
      tooltip: {
        enabled: true
      }
    }
  };
  constructor(
    private commonHttpService: CommonHttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
    private toastrService: ToastrService
  ) { }
  ngOnInit(): void {
    this.getInghtsWorkspaces();
    this.getAllWorkspaces();
    this.fetchData();
    this.fetchPlans()
    const pageCount = sessionStorage.getItem('pageSize');
    if (pageCount) this.pageCount = pageCount;
  }
  ngOnChanges(changes: SimpleChanges) {
  if (changes['count']) {
    this.getInghtsWorkspaces();
   }
  }
  fetchPlans() {
    this.commonHttpService.getPlanData('subscriptions').subscribe({
      next: (response: any) => {
        this.subscriptionData = {
          plancount: response.data[0].plancount,
          count: response.data[0].count
        }
        this.loadChartData()
      },
      error: (err: any) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error creating workspace'
          : errorList || 'Error creating workspace';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
      }
    })
  }
  fetchData() {
    const workspace = this.chartSelectedOption !== 'Show All' ? this.chartSelectedOption : null;
    let params: any = {}
    if (workspace) {
      params.workspace = workspace
    } else {
      params.workspace = ''
    }
    this.loaderView = true;
    this.commonHttpService.getChartData(`users`, params).subscribe({
      next: (response: any) => {
        const data = response?.data?.users || [];
        this.isChartDataEmpty = data.length === 0;
        this.rawData = {
          results: data,
          totalUsers: data.reduce((total: number, item: any) => total + parseInt(item.count || '0', 10), 0)
        };
        this.loadChartData();
        this.loaderView = false;
      },
      error: (err: any) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error creating workspace'
          : errorList || 'Error creating workspace';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      }
    })
  }
  loadChartData() {
    this.pieChartLabels = this.rawData.results.map((item: any) => item.roleId.toLowerCase().split(/[\s-_]+/).map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '));
    this.subscriptionChartLabels = this.subscriptionData.plancount.map(item => item.plan);

    this.pieChartData = {
      labels: this.pieChartLabels,
      datasets: [
        {
          data: this.rawData.results.map((item: any) => Number(item.count)),
          backgroundColor: CHART_COLORS.background,
          hoverBackgroundColor: CHART_COLORS.hoverBackground,
        }
      ]
    };
    this.subscriptionPieChart = {
      labels: this.subscriptionChartLabels,
      datasets: [
        {
          data: this.subscriptionData.plancount.map(item => Number(item.workspaceCount)),
          backgroundColor: CHART_COLORS.subscriptionBackground,
          hoverBackgroundColor: CHART_COLORS.subscriptionHover,
        }
      ]
    }
  }
  getAllWorkspaces() {
    this.loaderView = true;
    this.commonHttpService.getWorkspaces().subscribe({
      next: (res: any) => {
        res.data.workspaces.map((value: any) => {
          this.options?.push({ name: value.name });
          this.title = this.options![0].name
        })
        this.loaderView = false;
      },
      error: (err: any) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error creating workspace'
          : errorList || 'Error creating workspace';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      }
    })
  }
  getInghtsWorkspaces(param?: any) {
    this.loaderView = true;
    const params = {
      pageNumber: param?.pageNumber || '1',
      itemsPerPage: this.pageSize || '5'
    };
    if (this.selectedOption === 'Show All') {
      this.commonHttpService.getInsightsWorkspaces('asset-types', params).subscribe({
        next: (response: any) => {
          this.count = response.data[0].totalWorkspaceCount;
          this.dataSource = response.data[0].assettypes
          this.loaderView = false;
        }
      })
    } else {
      this.commonHttpService.getInsightsWorkspaces(`assets&workspace=${this.selectedOption}`, params).subscribe({
        next: (response: any) => {
          this.count = response.data[0].totalAssetTypeCount;
          this.dataSource = response.data[0].assets;
          this.loaderView = false;
        }
      })
    }
  }
  getWorkspace(event: string) {
    this.selectedOption = event;
    if (this.selectedOption === 'Show All') {
      this.displayedColumns = ['Workspaces', 'Asset Type Count'];
    } else {
      this.displayedColumns = ['Asset Type Name', 'Asset Count'];
    }
    this.getInghtsWorkspaces()
  }
  paginationEmitter(params: any) {
    paginationChange.next(true);
    // this.loaderView = true;
    const param = {
      provider: this.provider,
      status: this.status,
      pageNumber: params?.pageNumber || '1',
      itemsPerPage: this.pageSize || '5',
    };

    this.currentParams = params;
    let endpoint = '';
    if (this.selectedOption === 'Show All') {
      endpoint = 'asset-types';
      this.displayedColumns = ['Workspaces', 'Asset Type Count'];
    } else {
      endpoint = `assets&workspace=${this.selectedOption}`;
      this.displayedColumns = ['Asset Type Name', 'Asset Count'];
    }
    const loadRequest = this.commonHttpService.getInsightsWorkspaces(endpoint, param);
    if (loadRequest) {
      loadRequest.subscribe({
        next: (response: any) => {
          if (this.selectedOption === 'Show All') {
            this.dataSource = response?.data[0]?.assettypes;
            this.count = response.data[0].totalWorkspaceCount;
          } else {
            this.dataSource = response.data[0].assets;
            this.count = response.data[0].totalAssetTypeCount;
          }

          this.commonService.searchParam.next({
            pageNumber: params?.pageNumber,
            pageSize: params?.pageSize,
          });
          this.loaderView = false;
        },
        error: () => {
          this.loaderView = false;
        },
      });
    }
  }
  pageSizeEmitter(index: number) {
    paginationChange.next(true);
    this.pageSize = this.pageSizeOptions[index];
    this.pageCount = this.pageSize
    this.getInghtsWorkspaces()
  }
  getValue(event: string) {
    this.chartSelectedOption = event;
    this.fetchData()
  }

}
